// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"0aa5f2af","444":"c84b04dc","481":"5f5b85a3","845":"1bfcfd4f","875":"23844553","993":"4cea8124","997":"e924aa10"}[chunkId] + ".chunk.js";
};